import { css, type Theme } from "@emotion/react";

export const container = css`
  > :empty {
    display: none;
  }
`;

export const wrapper = {
  base: css`
    padding: 1rem;
  `,
  muted: (theme: Theme) => css`
    background-color: ${theme.system.backgroundMuted};
    box-shadow: none;
    border: none;
  `,
};

export const separator = css`
  margin: 0.5rem 0;
`;

export const disabled = css`
  &[disabled] {
    border: none;
    background-color: transparent;
  }
`;
